
import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import { all_routes } from '../../../router/all_routes';
import CardComponent from './CardComponent';

interface BannerProps {
    apiValues: any;
}



const FAQ: React.FC<BannerProps> = ({ apiValues }) => {

    const route = all_routes

    const categoriesslider = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* Top Categories */}
            <div className="section how-it-works" style={{
                backgroundImage: `url(assets/img/palani-bg-gray.jpg)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative'
            }}>
                <div className="container">
                    <div
                        className="d-flex align-items-center justify-content-between flex-wrap gap-3 aos"
                    >
                        <div className="section-header">
                            <span className="fw-medium text-secondary fs-18 fw-bold mb-2 d-inline-block">
                                {apiValues?.title || "Your Questions, Our Answers"}
                            </span>
                            <h2 className="mb-2 text-[#1D1753]">
                                {apiValues?.description || "Frequently Asked Questions"}
                            </h2>
                            <p className='text=[#1D1753]'>
                                {apiValues?.miniDescription || "Explore detailed answers to the most common questions about our platform."}
                            </p>
                        </div>

                    </div>


                    {/* yes */}

                    <div className="row mt-1" id="studyAbroadStepsCards">
                        {/* {[
                            {
                                question: "Research Your Options",
                                answer: "Explore countries, universities, and courses that match your interests and career goals.",
                                icon: "isax isax-search-normal"
                            },
                            {
                                question: "Get Expert Guidance",
                                answer: "Consult with our counselors to shortlist the best options and understand the application process.",
                                icon: "isax isax-user-tick"
                            },
                            {
                                question: "Prepare Your Documents",
                                answer: "Gather academic transcripts, test scores, SOPs, and other required documents.",
                                icon: "isax isax-document"
                            },
                            {
                                question: "Apply to Universities",
                                answer: "Submit your applications to selected universities with our support.",
                                icon: "isax isax-send-2"
                            },
                            {
                                question: "Secure Your Admission",
                                answer: "Receive offer letters and finalize your university choice.",
                                icon: "isax isax-award"
                            },
                            {
                                question: "Apply for Visa",
                                answer: "Get guidance on visa documentation and interview preparation.",
                                icon: "isax isax-global"
                            },
                            {
                                question: "Pre-Departure Support",
                                answer: "Attend our pre-departure sessions and get ready for your journey.",
                                icon: "isax isax-airplane"
                            }
                        ]. */}
                        {
                            (Array.isArray(apiValues?.stepsToImplementCards) ? apiValues?.stepsToImplementCards : []).map((item: any, index: number) => {

                                return (
                                    <CardComponent item={item} index={index} />

                                    // <div className="col-lg-12 col-md-12 mb-2" key={index}>
                                    //     <div
                                    //         className="shadow-sm rounded-3xl h-100 p-4 d-flex flex-column"
                                    //         style={{
                                    //             background:
                                    //                 "linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #ff0000, #4f8cff) border-box",
                                    //             border: "3px solid transparent",
                                    //             borderRadius: "1.5rem",
                                    //             transition: "box-shadow 0.3s, border-color 0.3s",
                                    //         }}
                                    //     >
                                    //         <div className="d-flex align-items-center mb-3">
                                    //             {/* <i className={`${item.icon} fs-4 text-secondary me-2`} /> */}
                                    //             <span className="fw-semibold text-[#1D1753]">{item.title}</span>
                                    //         </div>
                                    //         <div
                                    //             className="accordion-body px-3"
                                    //             style={{ borderRadius: "0.5rem" }}
                                    //         >
                                    //             {item.description}
                                    //         </div>
                                    //     </div>
                                    // </div>
                                )

                            }) || []

                        }


                    </div>
                    {/* yes */}

                </div>
            </div>
            {/* /Top Categories */}
        </>

    )
}

export default FAQ
